<template>
  <intro />
  <process />
  <points />
  <tariffs />
  <request color="dark" form-name="main" letter-theme="main" id="supportProdForm" />
</template>

<script setup lang="ts">
import intro from '~/components/sections/support/intro.vue';
import process from '~/components/sections/support/process.vue';
import points from '~/components/sections/support/points.vue';
import tariffs from '~/components/sections/support/tariffs.vue';
import request from '~/components/sections/request.vue';

definePageMeta({
  title: 'Поддержка ERP и MES систем TERPO | Сопровождение обновления',
  description: 'Поддержка TERPO по SLA: обновления ERP/MES системы, сопровождение и приоритетная техническая помощь.',
});
</script>
